import ReactGA from 'react-ga4'

import { store } from '@/store/store'
import { PriceMapType } from '@/types/card'

import { initialPriceSources } from '../initialState'

import { SET_USER_STATE } from './types'

const setRegion = async (region: string) => {
  const dispatch = store.dispatch
  const state = store.getState()

  console.log('setRegion', region)

  try {
    let priceSources = state.user.priceSources
    if (state.user.region !== region && state.user.priceSources[0] !== initialPriceSources[2]) {
      if (region == 'CA') {
        priceSources = ['face2face', state.user.priceSources[0], state.user.priceSources[1]] as Array<
          keyof PriceMapType
        >
      } else if (region === 'MX') {
        priceSources = ['tcgl', state.user.priceSources[0], state.user.priceSources[1]] as Array<keyof PriceMapType>
      }
    }

    priceSources.map((source) =>
      ReactGA.event({
        action: 'Init Price Source',
        category: 'Pricing',
        label: `region:${region}|source:${source}`,
        nonInteraction: true,
      }),
    )

    dispatch({
      payload: {
        priceSources,
        region,
      },
      type: SET_USER_STATE,
    })
  } catch (err) {
    console.error(err)
  }
}

export default setRegion
